import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiConstants } from 'src/app/constants/api-constants';

export interface ColumnConfig {
  key: string;
  label: string;
  type?: 'text' | 'link' | 'image';
}

@Component({
  selector: 'app-dtc-prediction-accordian-table',
  templateUrl: './dtc-prediction-accordian-table.component.html',
  styleUrl: './dtc-prediction-accordian-table.component.css'
})
export class DtcPredictionAccordianTableComponent implements OnInit {

  @Input() tableHeader: string;
  @Input() columns: ColumnConfig[] = [];
  @Input() set data(value: any[]) {
    this._allData = value || [];
    this.updatePaginatedData();
  }
  get data(): any[] { return this._allData; }

  paginatedData: any[] = [];

  pageIndex: number = ApiConstants?.global_settings?.pageIndex;
  pageSize: number = ApiConstants?.global_settings?.pageSize;
  pageSizeOptions: any = ApiConstants?.global_settings?.pageSizeOptions;

  private _allData: any[] = [];

  constructor(private _router: Router) { }

  ngOnInit() {
    this.updatePaginatedData();
  }

  /**
   * Updates paginated data
   */
  updatePaginatedData() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedData = this.data?.slice(startIndex, endIndex);
  }

  /**
   * Paginations dtc prediction accordian table component
   * @param event 
   */
  pagination(event: any) {
    this.pageIndex = event?.pageIndex;
    this.pageSize = event?.pageSize;
    this.updatePaginatedData();
    this._updatePaginatorLabel(event);
  }

  /**
   * Determines whether children has
   * @param row 
   * @returns true if children 
   */
  hasChildren(row: any): boolean {
    return row?.children && row?.children?.length > 0;
  }

  /**
   * Links action
   * @param childDetail 
   * @param rowDetail 
   */
  linkAction(childDetail: any, rowDetail: any) {
    this._router?.navigate(['case/predictions'],
      {
        queryParams: {
           vin: childDetail?.vehicle, dtc: rowDetail?.dtcCode, edate: this._formatEdate(new Date()), risk: parseFloat(childDetail?.risk), prediction: parseFloat(childDetail?.confidence)
        }
      });
  }

  /**
   * Formats edate
   * @param date 
   * @returns edate 
   */
  private _formatEdate(date: Date): string {
        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    }

  /**
   * Updates paginator label
   * @param event 
   */
  private _updatePaginatorLabel(event: any) {
    let list = document.getElementsByClassName('mat-paginator-range-label');
    if (list?.length >= 1) {
      const currentLength = event?.length;
      const currentPage = event?.pageIndex;
      const currentSize = event?.pageSize;
      let from = (currentSize * currentPage) + 1;
      let to = Math.min(currentLength, currentSize * (currentPage + 1));
      let toFrom = (currentLength == 0) ? 0 : `${from} - ${to}`;
      let totalPages = Math.ceil(currentLength / currentSize);
      let pageNumber = (currentLength == 0) ? `0 of 0` : `${currentPage + 1} of ${totalPages}`;
      list[0].innerHTML = `Page ${pageNumber} (${toFrom} of ${currentLength})`;
    }
  }
}
